export default "__VITE_ASSET__f16125ed__"